import { blobToDataUri } from './blobToDataUri'
import { fetchImageToBlob } from './fetchImageToBlob'

export async function fetchImageToDataUri(
	url: string,
): Promise<string | undefined> {
	const blob = await fetchImageToBlob(url)
	if (!blob) return undefined
	return blobToDataUri(blob)
}
